"use client";

import { useEffect, useState, Suspense } from "react";
import { usePathname } from "next/navigation";

import Context from "@/context/Context";
import DeliveryReturn from "@/components/modals/DeliveryReturn";
import MobileMenu from "@/components/modals/MobileMenu";
import ScrollTop from "@/components/common/ScrollTop";
import Header4 from "@/components/headers/Header4";
import Footer1 from "@/components/footers/Footer1";
import CookieBanner from "@/components/CookieBanner";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ClientShell({ children }) {
  const pathname = usePathname();
  const isAdmin = pathname?.startsWith("/admin");
  const isDashboard = pathname?.startsWith("/contul-meu");
  const isClient = !isAdmin && !isDashboard;

  const [scrollDirection, setScrollDirection] = useState("down");

  // bootstrap esm import (o singură dată)
  useEffect(() => {
    import("bootstrap/dist/js/bootstrap.esm").catch(() => { });
  }, []);

  // header background on scroll (doar non-admin)
  useEffect(() => {
    if (isAdmin) return;

    const handleScroll = () => {
      const header = document.querySelector("header");
      if (!header) return;

      if (window.scrollY > 100) header.classList.add("header-bg");
      else header.classList.remove("header-bg");
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isAdmin]);

  // hide/show header on scroll direction
  useEffect(() => {
    if (isAdmin) return;

    let last = window.scrollY;

    const handleScroll = () => {
      const y = window.scrollY;

      if (y > 250) setScrollDirection(y > last ? "down" : "up");
      else setScrollDirection("down");

      last = y;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isAdmin, pathname]);

  useEffect(() => {
    if (isAdmin) return;

    const header = document.querySelector("header");
    if (!header) return;

    header.style.top = scrollDirection === "down" ? "0px" : "-185px";
  }, [isAdmin, scrollDirection]);

  // close bootstrap modals/offcanvas on route change
  useEffect(() => {
    try {
      const bootstrap = require("bootstrap");

      document.querySelectorAll(".modal.show").forEach((modal) => {
        const inst = bootstrap.Modal.getInstance(modal);
        if (inst) inst.hide();
      });

      document.querySelectorAll(".offcanvas.show").forEach((offcanvas) => {
        const inst = bootstrap.Offcanvas.getInstance(offcanvas);
        if (inst) inst.hide();
      });
    } catch { }
  }, [pathname]);

  // wow init
  useEffect(() => {
    try {
      const { WOW } = require("wowjs");
      const wow = new WOW({ mobile: false, live: false });
      wow.init();
    } catch { }
  }, [pathname]);

  // preloader disable (o singură dată)
  useEffect(() => {
    document.documentElement.dir = "ltr";
    const preloader = document.getElementById("preloader");
    if (preloader) preloader.classList.add("disabled");
  }, []);

  return (
    <>
      <div className="preload preload-container" id="preloader">
        <div className="preload-logo">
          <div className="spinner"></div>
        </div>
      </div>

      <Context>
        {!isAdmin && (
          <Suspense fallback={null}>
            <Header4 />
          </Suspense>
        )}
        <ToastContainer />
        <div id="wrapper" className={isClient ? "is-client" : ""}>{children}</div>
        <CookieBanner />
        {!isAdmin && <DeliveryReturn />}
        {!isAdmin && <MobileMenu />}
        {!isAdmin && <Footer1 />}
      </Context>

      <ScrollTop />
    </>
  );
}
